import { render } from "./findBackAccount.vue?vue&type=template&id=52bb51de&scoped=true"
import script from "./findBackAccount.vue?vue&type=script&lang=js"
export * from "./findBackAccount.vue?vue&type=script&lang=js"

import "./findBackAccount.vue?vue&type=style&index=0&id=52bb51de&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-52bb51de"

export default script